var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "hue", on: { "mousedown": function mousedown($event) {
        $event.preventDefault();$event.stopPropagation();return _vm.selectHue.apply(null, arguments);
      } } }, [_c('canvas', { ref: "canvasHue" }), _vm._v(" "), _c('div', { staticClass: "slide", style: _vm.slideHueStyle })]);
};
var staticRenderFns = [];

export { render, staticRenderFns };